import LeavesView  from '../LeavesView.vue'
import LeaveList   from '../Pages/LeaveList.vue'
import LeaveCreate from '../Pages/LeaveCreate.vue'
import LeaveDetail from '../Pages/LeaveDetail.vue'

const routes = [
  {
    path: '/licencias',
    component: LeavesView,
    children: [
      { path: '',           name: 'licenses-list',   component: LeaveList   },
      { path: 'crear',      name: 'licenses-create', component: LeaveCreate },
      { path: 'editar/:id', name: 'licenses-edit',   component: LeaveCreate },
      { path: ':id',        name: 'licenses-detail', component: LeaveDetail },
    ],
  },
]

export default routes
